import { h } from 'preact';
import { registerPatternDecoder } from './index';
import { IToastOptions } from '@/components/create-toast';
import { defaultSuccessImg } from '@/assets/success';

registerPatternDecoder(/^\{slot-success\}/, (match, options: IToastOptions) => {
  const successImg = defaultSuccessImg;
  return <img src={successImg} alt="🪙" style={{ height: '1em', verticalAlign: 'middle' }} />;
});
